import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { white } from '../../../styles/colors';

// Score range colors using theme system
export const scoreColors = {
	needsWork: THEME.colors.danger.main, // 1-3: Red
	developing: THEME.colors.warning.main, // 4-6: Yellow/Orange
	proficient: THEME.colors.success.main, // 7-8: Green
	excellent: THEME.colors.primary.main, // 9-10: Blue
};

// Size configurations
const sizes = {
	small: {
		diameter: 32,
		fontSize: 14,
		fontWeight: 600 as const,
	},
	medium: {
		diameter: 48,
		fontSize: 18,
		fontWeight: 600 as const,
	},
	large: {
		diameter: 64,
		fontSize: 24,
		fontWeight: 700 as const,
	},
};

export const styleSheet = StyleSheet.create({
	// Container styles
	containerSmall: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: sizes.small.diameter,
		height: sizes.small.diameter,
		borderRadius: '50%',
		fontSize: sizes.small.fontSize,
		fontWeight: sizes.small.fontWeight,
		color: white,
	},
	containerMedium: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: sizes.medium.diameter,
		height: sizes.medium.diameter,
		borderRadius: '50%',
		fontSize: sizes.medium.fontSize,
		fontWeight: sizes.medium.fontWeight,
		color: white,
	},
	containerLarge: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: sizes.large.diameter,
		height: sizes.large.diameter,
		borderRadius: '50%',
		fontSize: sizes.large.fontSize,
		fontWeight: sizes.large.fontWeight,
		color: white,
	},

	// Color styles
	needsWork: {
		backgroundColor: scoreColors.needsWork,
	},
	developing: {
		backgroundColor: scoreColors.developing,
	},
	proficient: {
		backgroundColor: scoreColors.proficient,
	},
	excellent: {
		backgroundColor: scoreColors.excellent,
	},
});
